import { navigateTo } from "../../../../../navigationService/navigationServiceFunctions";

export function handleFeatureDefault(feature: any) {
    const [layerName, id] = feature?.id.split('.')
    const objectType = getObjectTypeFromLayerName(layerName)
    navigateTo(`/app/table/${objectType}/${id}`)
}

export function getObjectTypeFromLayerName(layerName: string): string {
    return layerName
        .slice(2)
        .replace(/_.*/, '')
        .replace(/[\d-]/g, '')
        .replace('ForFilters', '')
        .replace('SQL', '') + 's';
}